import { defer } from './defer';
export function iif(condition, trueResult, falseResult) {
    return defer(() => (condition() ? trueResult : falseResult));
}
//# sourceMappingURL=iif.js.map